import ApiService from "@/core/services/api.service";
import i18nService from "@/core/services/i18n.service.js";

const STATUSES = ["Inaktív", "Aktív", "Lezárt"];

const state = {
  errors: null,
  collection: [],
};

const getters = {
  filingBookCollection(state) {
    return state.collection;
  },

  getFilingBookByID: (state) => (id) => {
    let item = state.collection.find((item) => item.id == id);
    if (!item) {
      item = { name: "" };
    }
    return item;
  },
};

const actions = {
  fetchFilingBook(context) {
    return new Promise((resolve) => {
      let appLocale = i18nService.getUserActiveLanguage();
      ApiService.get("filings/admin/filingBook").then(({ data }) => {
        // create localized fields
        let dataLocalized = data.map((item) => {
          if (item.translations) {
            let translations = item.translations[appLocale];
            if (translations) {
              Object.keys(translations).forEach((property) => {
                item[property] = item.translations[appLocale][property];
              });
              item.translated = true;
            } else {
              for (const [key, value] of Object.entries(
                item.translations[Object.keys(item.translations)[0]]
              )) {
                if ("attachments" != key && "custom_fields" != key) {
                  item[key] = value;
                }
              }
            }
          }
          item.status = STATUSES[item.status];

          return item;
        });

        context.commit("fetchFilingBook", dataLocalized);
        resolve();
      });
    }).catch((error) => {
      console.log("Error!: ", error);
    });
  },
};

const mutations = {
  fetchFilingBook(state, data) {
    state.collection = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
